export const verificationVariant = {
  authCode: 'authCode',
  recoveryCode: 'recoveryCode'
};
